import { render } from "./pricing-delete.vue?vue&type=template&id=1fb1d612"
import script from "./pricing-delete.vue?vue&type=script&lang=js"
export * from "./pricing-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__